import snapshot from './developmentFirestoreGrowthStrategySample.v0.1.json';
import { accountForCapturedAnswers } from './capturedAnswerCompatibility';
import type { AdvisoryBriefDocumentInputV01 } from './types';

/**
 * Metadata for the completed development run captured in the adjacent JSON
 * fixture. The browser never reads another user's Firestore path at runtime.
 */
export const DEVELOPMENT_FIRESTORE_GROWTH_STRATEGY_SAMPLE_SOURCE = snapshot.source;

/** Five backend answers kept in the exact numeric `readOrder` captured from Firestore. */
export const DEVELOPMENT_FIRESTORE_GROWTH_STRATEGY_SAMPLE = accountForCapturedAnswers(
  snapshot.document as unknown as AdvisoryBriefDocumentInputV01
);
